export type ColorConfig = Record<string, string>;

const colors: ColorConfig = {
  ISSUE_HEADER: '#f8f8f8',
  C_GRAY: '#e2e0d4',
};

export default colors;
